// src/services/notificationService.js
import api from '@/api'

function getUserId() {
  const user = JSON.parse(localStorage.getItem('user') || '{}')
  return user?.id
}

export default {
  async getAll() {
    const res = await api.get('/notifications')
    const all = res.data?.notifications?.data || []
    const userId = getUserId()
    return all.filter(n => n.notifiable_id === userId)
  },

  async getUnreadCount() {
    const res = await api.get('/notifications')
    const all = res.data?.notifications?.data || []
    const userId = getUserId()
    return all.filter(n => n.notifiable_id === userId && n.read_at === null).length
  },

  async markAllAsRead() {
    return api.post('/notifications/mark-all-read')
  },

  async markAsRead(id) {
    return api.post('/notifications/mark-as-read', {
      notification_ids: [id]
    })
  }
}
